import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';


/**
 * API объектов, на которых проводятся работы
 */
@Injectable()
export class WorkingObjectsApiService extends ApiService {
    baseUrl = 'working-object';

    /**
     * Путь для связывания и постраничного получения оборудования для объекта
     * @TODO Лучше разделить точки, чтобы создание шло на «POST /equipment», а получение на  «GET /equipment-pages»
     * @param objectId
     */
    getEquipmentPath(objectId: number): string {
        return `${this.baseUrl}/${objectId}/equipment`;
    }

    /**
     * Путь для связывания и получения специалистов объекта
     * @TODO Сделать пагинацию для получения и разделить API на связывание и постраничное получение
     * @param objectId
     */
    getSpecialistPath(objectId: number): string {
        return `${this.baseUrl}/${objectId}/specialists`;
    }

    /**
     * Пусть для получения списка заявок
     * @param deviceId
     */
    getControlOrdersPath(deviceId: number) {
        return `${this.baseUrl}/${deviceId}/control-orders`;
    }

    /**
     * Путь для создания и связывания технического устройства с объектом
     * @param objectId
     */
    getTechnicalDevicesPath(objectId: number): string {
        return `${this.baseUrl}/${objectId}/technical-device`;
    }
}
